if ($('.lening-samenstellen-trigger-js').length !== 0) {
    jQuery(document).ready(function($) {

        $('#lening_samenstellen').find('input[type="text"]').click(function(){
            $(this).select();
        });

        $('select#looptijdbox').on('change', function(){
            $('#looptijd').val($(this).children('option:selected').val());
            getInterest();
        });

        $('input[type="text"]').on('change, blur, focusout', function(){

            if( typeof $(this).data('holder') !== 'undefined' ) {
                value = $(this).val(); //het bedrag

                if(value > 75000){ //als het bedrag hoger is dan 5000 moet het bedrag 5000 worden
                    value = 75000;
                }else if( value < 5000 ){ //als het bedrag lager is dan 0 moet het bedrag 0 worden
                    value = 5000;
                }

                $(this).val(value); // stel opnieuw de waarde in.

                var id = $(this).data('holder'); //haal het id van het corresponderende veld op dat de data moet vasthouden
                $('input#' + id).val(value); //stel het juiste getal in van dit veld
            }

        });


        $('#productvorm').on('change', function(e){
            productvorm = $(this).val();

            if(productvorm == 'Persoonlijke lening' || productvorm == 'Eigenhuis Persoonlijke lening'){

                $('div.looptijd-wrapper').show();
                $('div.maandlast-wrapper').hide();

                $('table.lening_samenstellen tr:first td:last').text('Maandtermijn');

            }else{

                $('div.maandlast-wrapper').show();
                $('div.looptijd-wrapper').hide();

                $('table.lening_samenstellen tr:first td:last').text('Theoretische looptijd');
            }

            getInterest();
        });

        $('#looptijd, #maandlast').on('change', function(e){
            getInterest();
        })

        setSlider = function (elem, min, max, startVal, step, callback) {

            min = typeof min == 'undefined' ? 0 : Number(min);
            max = typeof max == 'undefined' ? 75000 : Number(max);
            startVal = typeof startVal == 'undefined' ? 0 : Number(startVal);
            step = typeof step == 'undefined' ? 0 : Number(step);
            parentElem = elem.parent().attr('class');

            elem.ionRangeSlider({
                from: startVal,
                min: min,
                max: max,
                step: step,
                onStart: function(data) {
                    dataHolder = $(data.input[0]).data('holder');
                    $('input[id="'+dataHolder+'"]').val(data.from);
                    $(parentElem + ' .rails').css({backgroundPosition: '0 -6px'});
                },
                onChange: function(data) {
                    dataHolder = $(data.input[0]).data('holder');
                    $('input[id="'+dataHolder+'"]').val(data.from);
                },
                onFinish : function(data) {
                    getInterest();
                    $('input#leenbedrag').trigger('blur');
                }

            });

            $('input[type="text"]#'+elem.data('holder')).on('keyup', function(e){
                value = $(this).val(); //het bedrag

                if(value > 5000){ //als het bedrag hoger is dan 5000 moet het bedrag 5000 worden
                    value = 5000;
                }else if( value < 0 ){ //als het bedrag lager is dan 0 moet het bedrag 0 worden
                    value = 0;
                }

                $(this).val(value); // stel opnieuw de waarde in.

                var id = $(this).data('holder'); //haal het id van het corresponderende veld op dat de data moet vasthouden
                $('input#' + id).val(value); //stel het juiste getal in van dit veld

                   elem.data('ionRangeSlider').update({
                        from : value
                   });

                getInterest(); // verwerk alle data

            });

            getInterest();
        };


        $('#lening_samenstellen').find('.slider').each(function(index, el) {
            setSlider($(this), $(this).attr('min'), $(this).attr('max'), $(this).attr('start-val'), $(this).attr('step'));
        });


        $(document).on('change blur focusout', 'input#leenbedrag', function(){
            _this = $(this);

            var checkedMaandlast = $('#maandlast').children('option:checked').index();

            $('input#leenbedrag').val(_this.val());

            var multiplier = [0.01, 0.015, 0.020];

            $('#maandlast').children().remove();

            for(i = 0; i < 3; i++)
            {
                maandlast = _this.val() * multiplier[i]
                option = '<option '+(i == checkedMaandlast ? 'selected' : '')+' value="'+maandlast+'">€' + maandlast.toString().replace('.', ',') + ' p/m</option>';
                $('#maandlast').append(option);
            }

            getInterest();

        });


        $('input#leenbedrag').trigger('change');

        getInterest();

    });

    var getRentetarievenTimeout = null; //timeout init for getting interest rates

    function getInterest()
    {
        var leenbedrag = $('input#leenbedrag').val();
        var productvorm = $('select#productvorm').children('option:selected').val();
        var looptijd = $('#looptijd').val();
        var maandlast = $('#maandlast').val();

        if (getRentetarievenTimeout) clearTimeout(getRentetarievenTimeout);

        getRentetarievenTimeout = window.setTimeout(function(){
            $.get("/rentetarieven/getRentetarief/", {
                productvorm: productvorm.toLowerCase(),
                leenbedrag: leenbedrag,
                looptijd: looptijd,
                maandlast: maandlast,
            }, function(data){
                interest = parseFloat(data);

                if(productvorm == 'Persoonlijke lening' || productvorm == 'Eigenhuis Persoonlijke lening'){
                    $('td.result:last').text("€ " + getMaandlastFromInterest(leenbedrag, interest, looptijd).toString().replace('.',','));
                    $('td.result:first').text(interest.toString().replace('.', ',')+'%');

                    if($('.belasting-row').length > 0){
                        if($('.belasting-row').hasClass('pl')){
                            belastingVoordeel =  ((getMaandlastFromInterest(leenbedrag, interest, looptijd) * looptijd) - leenbedrag) * 0.42;
                            $('td.belasting-result').html('€ '+belastingVoordeel.toFixed(2).toString().replace('.', ','));
                            $('.belasting-row').show();
                        }else{
                            $('.belasting-row').hide();
                        }
                    }


                }

                if(productvorm == 'Doorlopend krediet' || productvorm == 'Eigenhuis Doorlopend krediet'){
                    $('td.result:last').html(getLooptijdFromMaandlast(leenbedrag, interest, maandlast).toFixed(0) + ' <span class="xs-text">maanden</span>');
                    $('td.result:first').text(interest.toString().replace('.', ',')+'%');

                    if($('.belasting-row').length > 0){
                        if($('.belasting-row').hasClass('dk')){
                            belastingVoordeel =  ((maandlast * getLooptijdFromMaandlast(leenbedrag, interest, maandlast).toFixed(0)) - leenbedrag) * 0.42;
                            $('td.belasting-result').html('€ '+belastingVoordeel.toFixed(2).toString().replace('.', ','));
                            $('.belasting-row').show();
                        }else{
                            $('.belasting-row').hide();
                        }
                    }


                }

            });
        },  500);
    }

    function getMaandlastFromInterest(leenbedrag, rente, looptijd)
    {
        var nominaal = (Math.pow((1 + rente / 100),(1 / 12)) - 1) * 100;

       return value = annu(leenbedrag, (nominaal/100), looptijd).toFixed(2);
    }

    function getLooptijdFromMaandlast(leenbedrag, rente, maandlast)
    {
        var nominaal = (Math.pow((1 + rente / 100),(1 / 12)) - 1) * 100;
        var x = maandlast - (leenbedrag * (nominaal / 100));
        return Math.log(maandlast / x) / Math.log(1 + (nominaal / 100));
    }

    function annu(bedrag, rentevoet, periode){

        waarde = (rentevoet / (1 - Math.pow((1+rentevoet), -periode))) * bedrag;
        return waarde;
    }
}